<div class="spec">
  <span class="spec__key">{{ key }}</span>
  <span class="spec__value">{{ value }}</span>
</div>
